export default function _forceReduced(x) {
  return {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/es/internal/_forceReduced.js
// module id = 662
// module chunks = 1